/* eslint consistent-return: 0 */ //
import { debounce } from 'lodash';

const isInViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const rightAlignWithViewport = elem => {
  const secondLevelLi = elem;
  const bounding = secondLevelLi.getBoundingClientRect();
  if (bounding.left + bounding.width >= document.documentElement.clientWidth) {
    const moveDistance = bounding.left + bounding.width - document.documentElement.clientWidth;
    secondLevelLi.style.transform = `translateX(0)`;
    secondLevelLi.style.transform = `translateX(-${moveDistance}px)`;
  }
};

const alignWithViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  const thirdLevelLi = elem;
  if (bounding.left + bounding.width >= document.documentElement.clientWidth) {
    let moveDistance = -bounding.width;
    const parentLi = thirdLevelLi.closest('.menu-item-has-children');
    const parentWidth = parentLi.getBoundingClientRect().width;
    moveDistance -= parentWidth;
    thirdLevelLi.style.transform = `translateX(0)`;
    thirdLevelLi.style.transform = `translateX(${moveDistance}px)`;
  }
};

document.body.addEventListener('mouseover', event => {
  if (
    !event.target.matches('.primaryNav-mainMenu li > a') &&
    !event.target.matches('.primaryNav-mainMenu li > a *') &&
    !event.target.matches('.primaryNav-mainMenu li')
  ) {
    return;
  }

  const secondLevelNav = document.querySelectorAll(
    '.primaryNav-mainMenu > li > .primaryNav-subMenu',
  );
  const thirdLevelNav = document.querySelectorAll('.primaryNav-subMenu .primaryNav-subMenu');

  for (let i = 0; i < secondLevelNav.length; i += 1) {
    if (!isInViewport(secondLevelNav[i])) {
      rightAlignWithViewport(secondLevelNav[i]);
    }
  }

  for (let i = 0; i < thirdLevelNav.length; i += 1) {
    if (!isInViewport(thirdLevelNav[i])) {
      alignWithViewport(thirdLevelNav[i]);
    }
  }
});

const calculateOffscreenElements = () => {
  const thirdLevelNav = document.querySelectorAll('.primaryNav-subMenu .primaryNav-subMenu');

  for (let i = 0; i < thirdLevelNav.length; i += 1) {
    if (!isInViewport(thirdLevelNav[i])) {
      alignWithViewport(thirdLevelNav[i]);
    } else {
      thirdLevelNav[i].style.transform = `translateX(0)`;
    }
  }
};

window.addEventListener('resize', debounce(calculateOffscreenElements, 300));

const getNextSibling = (elem, selector) => {
  // Get the next sibling element
  if (!elem?.nextElementSibling) {
    return;
  }

  let sibling = elem.nextElementSibling;

  // If there's no selector, return the first sibling
  if (!selector) return sibling;

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }

  return null;
};

const getPreviousSibling = (elem, selector) => {
  // Get the next sibling element
  if (!elem?.previousElementSibling) {
    return;
  }

  let sibling = elem.previousElementSibling;
  // If there's no selector, return the first sibling
  if (!selector) return sibling;

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
};

const getClosest = (elem, selector) => {
  let baseEl = elem;
  for (; baseEl && baseEl !== document; baseEl = baseEl.parentNode) {
    if (baseEl.matches(selector)) return baseEl;
  }
  return null;
};

let opened = [];

const reset = () => {
  const arrayLength = opened.length;
  for (let i = 0; i < arrayLength; i += 1) {
    const subNav = opened[i];
    subNav.style.display = '';
    subNav.setAttribute('aria-hidden', 'true');
    subNav.setAttribute('aria-expanded', 'false');
  }

  opened = [];
};

function open(el) {
  const openEl = el;
  openEl.style.display = 'block';
  openEl.setAttribute('aria-hidden', 'false');
  openEl.setAttribute('aria-expanded', 'true');
  opened.push(openEl);
}

document.addEventListener('click', event => {
  if (!event.target.closest('[aria-hidden]')) {
    reset();
  }
});

let reverseTab = false;
document.addEventListener('keydown', event => {
  if (event.shiftKey && event.key === 'Tab') {
    reverseTab = true;
  } else {
    reverseTab = false;
  }
});

const hasNav = document.querySelector('.primaryNav-container');

// event delegation
document.addEventListener('focusin', event => {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth <= 940) {
    return;
  }

  // exit if no nav
  if (!hasNav) {
    return;
  }

  const { target } = event;
  const hasPopup = target.getAttribute('aria-haspopup') === 'true';
  const parentMenu = getClosest(target, '[aria-haspopup]');
  const inMenu = getClosest(target, '.menu-item');
  const firstUl = document.querySelector('.primaryNav-mainMenu li ul');
  const parentLi = getClosest(target, 'li');
  const previousLi = getPreviousSibling(parentLi, 'li');
  const nextLi = getNextSibling(parentLi, 'li');

  let thirdLevel = false;

  if (!hasPopup && getPreviousSibling(target.parentNode.parentNode, '[aria-haspopup]') !== null) {
    thirdLevel = true;
  }

  if (previousLi && !thirdLevel) {
    const previousLiTarget = previousLi.querySelector('a');

    // check if entered item isn't directly under the main menu as you don;t want to close yet if it is
    const levelOneHit = previousLiTarget.parentNode.parentNode.classList.contains(
      'primaryNav-mainMenu',
    );

    // if previous had a dropdown close it
    if (previousLi.querySelector('.primaryNav-subMenu')) {
      if (previousLi.querySelector('.primaryNav-subMenu').style.display === 'block') {
        previousLi.querySelector('.primaryNav-subMenu').style.display = 'none';
      }
    }

    if (previousLiTarget.getAttribute('aria-haspopup') && levelOneHit) {
      reset();
    }
  }

  if (nextLi && reverseTab) {
    const nextLiTarget = nextLi.querySelector('a');
    if (nextLiTarget.getAttribute('aria-haspopup')) {
      reset();
    }
  }

  if (!hasPopup && parentMenu === null && !thirdLevel) {
    reset();
  }

  if (hasPopup) {
    const subNav = getNextSibling(event.target, '.primaryNav-subMenu');
    open(subNav);
  }

  // Closes first Ul if reverse tabbing out of nav
  if (!inMenu && firstUl.getAttribute('aria-expanded') === 'true') {
    reset();
  }
});

const navArrows = document.querySelectorAll('.primaryNav .drop-icon');
navArrows.forEach(el => {
  el.addEventListener('click', () => {
    el.classList.toggle('drop-icon-up');
  });
});
